export default {
    applicationName: "MadVolley",
    applicationNameLite: "MadVolley FREE",
    website: "http://www.madvolley.org/",
    broadcastMessagesUrl: "http://www.maddoofy.org/madvolley-messages",
    marketUrl: "market://details?id=org.maddoofy.madvolley",
    demo: "false",
    demoInfo: "This is a demo version",
    fullVersion: "Full Version",
    lite: "FREE",
    ok: "OK",
    yes: "Yes",
    no: "No",
    debug: "Debug",
    back: "Back",
    reset: "Reset",
    close: "Close",
    cancel: "Cancel",
    retry: "Retry",
    gameover: "Game over",
    youWin: "You win!",
    youLost: "You lost!",
    trophyAchieved: "Trophy achieved",
    matchball: "Matchball",
    reallyquit: "Back to main menu?",
    quickstart: "Quickstart",
    newgame: "New game",
    trophies: "Trophies",
    trophiesWon: "Trophies won",
    settings: "Settings",
    general: "General",
    quit: "Quit",
    loading: "Loading...",
    easy: "Easy",
    normal: "Normal",
    hard: "Hard",
    chooseLevel: "Level",
    chooseDifficulty: "Difficulty",
    chooseCharacter: "Character",
    chooseGameType: "Game Type",
    pause: "Pause",
    resume: "Resume",
    paused: "Paused",
    versus: "vs",
    expired: "Demo expired",
    expiredinfo: "Visit www.maddoofy.org for more information",
    difficulty: "Difficulty",
    difficultyDesc: "The difficulty controls the strength of your opponent",
    sound: "Sound",
    soundDesc: "Disabling sound effects may improve performance during gameplay",
    music: "Music",
    musicDesc: "Turn background music on and off",
    visitWebsite: "Visit our website",
    visitWebsiteDesc: "You can find more information about our mobile games on our website",
    tutorial: "Tutorial",
    tutorialDesc: "Quick and easy start to mad Volleyball!",
    graphics: "Graphics",
    graphicsDesc: "Lower graphics settings improve performance during gameplay",
    jumpSensibility: "Jump Sensibility",
    settingsGame: "Game",
    settingsSound: "Sound",
    settingsInput: "Input",
    settingsGraphics: "Graphics",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Gold",
    finished: "You've got the golden trophy!",

    gameWinText: "Congratulations, you win! Stay tuned! Do you want to play again?",
    gameLostText: "Sorry, you lost! Better luck next time. Do you want to play again?",

    share: "Share your achievements",
    shareSubject: "I won a MadVolley match!",
    shareMessage: "Hey guys, I just won a MadVolley match (%s) at level '%s' with %d:%d :-)",

    gameTypeBestOf5: "Best-of-5",
    gameTypeBestOf5Info: "Achieve 3 points to win a match. Win 3 matches to win the game.",
    gameTypeTime: "Time is short",
    gameTypeTimeInfo: "Achieve as many points as possible within 60 seconds. When time runs out and the scores are equal the next point wins the game.",
    gameTypeBomb: "Boooom!",
    gameTypeBombInfo: "Throw the bomb towards your opponent. Let the bomb explode over your opponent's playing field to earn a point. Win the game with 10 points.",

    tutorial1: "Welcome to MadVolley!",
    tutorial2: "That's you!",
    tutorial3: "To move around, touch the display like this:",
    tutorial4_1: "To jump, either click on the display like this...",
    tutorial4_2: "...or move your finger like this...",
    tutorial4_3: "...or click your trackball like this:",
    tutorial5: "Only 5 contacts are allowed before passing the ball over the net!",
    tutorial6: "Hit the ball with your head to start the game!",
    tutorial7: "And now, have fun!",

    trophy_winning_1_1: "Win 1 Best-of-5 game",
    trophy_winning_3_1: "Win 3 Best-of-5 games straight",
    trophy_winning_5_1: "Win 5 Best-of-5 games straight",
    trophy_winning_10_1: "Win 10 Best-of-5 games straight",
    trophy_winning_25_1: "Win 25 Best-of-5 games straight",
    trophy_winning_1_2: "Win 1 Time-is-short game",
    trophy_winning_3_2: "Win 3 Time-is-short games straight",
    trophy_winning_5_2: "Win 5 Time-is-short games straight",
    trophy_winning_10_2: "Win 10 Time-is-short games straight",
    trophy_winning_25_2: "Win 25 Time-is-short games straight",
    trophy_winning_1_3: "Win 1 Boooom game",
    trophy_winning_3_3: "Win 3 Boooom games straight",
    trophy_winning_5_3: "Win 5 Boooom games straight",
    trophy_winning_10_3: "Win 10 Boooom games straight",
    trophy_winning_25_3: "Win 25 Boooom games straight",
    trophy_whitewash_1: "Win 1 game straight to nil",
    trophy_whitewash_3: "Win 3 games straight to nil",
    trophy_whitewash_5: "Win 5 games straight to nil",
    trophy_whitewash_10: "Win 10 games straight to nil",
    trophy_whitewash_25: "Win 25 games straight to nil",

    graphicsQualityHint: "MadVolley estimated the optimal graphics settings for your device. Do you want to save these settings?\nYou can modify the graphics quality in the game settings at anytime."
};
